
export const MSG_ConfigErr: string = `Service Unavailable <br/> (or) <br/> Juri's Detail is not yet configured for this Agency/ Tenant! <br/><br/> This may cause unexpected errors. <br/><br/>Please contact the administrator.`;
export const MSG_InactiveConfigErr: string = `Site is no longer available. <br/><br/>Please contact the administrator.`;


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/messages.ts